// extracted by mini-css-extract-plugin
module.exports = {"dotSeparatorRoot":"DotSeparator_dotSeparatorRoot__PER5U"};